import Image from 'next/image'
import { cn } from '@/utilities/ui'
import { ChevronsRight } from 'lucide-react'
import Link from 'next/link'
import RichText from '@/components/RichText'

export const CardWithIconAndButton = ({
  links,
  title,
  icon,
  description,
  textColor = 'text-card-foreground',
  btnClassName,
  overlay = false,
  backgroundColor,
}: {
  links?: any
  title?: any // Changed from string to any to handle richText
  icon?: any
  description?: any // Changed from string to any to handle richText
  textColor?: string
  btnClassName?: string
  overlay?: boolean
  backgroundColor?: string
}) => {
  return (
    <div className="group h-full flex flex-col mx-2 md:mx-4 lg:mx-0">
      <div className="relative border border-border rounded-xl p-3 min-h-[30vh] space-y-7 flex-1 flex flex-col">
        <div
          className={cn('absolute inset-0 rounded-xl bg-card shadow-md z-[-1]', {
            'bg-primary': backgroundColor === 'black',
            'bg-destructive': backgroundColor === 'destructive',
          })}
        />
        <div className="flex flex-row  items-center gap-4">
          <div className="relative flex items-center justify-center w-20 h-20 rounded-xl overflow-hidden z-[1]">
            <span className="icon-caren w-full h-full flex items-center justify-center">
              {icon && icon.url && (
                <Image
                  src={icon.url}
                  alt={icon.alt || 'Service icon'}
                  width={80}
                  height={80}
                  className="w-full h-full object-contain bg-transparent"
                  style={{ objectFit: 'contain' }}
                  priority
                />
              )}
            </span>
          </div>
          {title && typeof title === 'object' && title.root ? (
            <RichText
              data={title}
              enableGutter={false}
              enableProse={false}
              className={`text-lg sm:text-xl md:text-2xl lg:text-3xl font-semibold line-clamp-2 break-words text-black`}
            />
          ) : (
            <h3
              className={`text-lg sm:text-xl md:text-2xl lg:text-3xl font-semibold line-clamp-2 break-words text-black`}
            >
              {title}
            </h3>
          )}
        </div>

        {description && typeof description === 'object' && description.root ? (
          <RichText
            data={description}
            enableGutter={false}
            enableProse={false}
            className={` ${textColor} text-base flex-1`}
          />
        ) : (
          <p className={` ${textColor} font-light flex-1`}>{description}</p>
        )}
        <div>
          {links?.map((item: any, index: any) => {
            const link = item.link
            return (
              <div key={index} className="relative overflow-hidden rounded-full inline-flex">
                <Link
                  key={link?.id || index}
                  href={link?.url}
                  className={cn(
                    'inline-flex items-center bg-primary text-primary-foreground cursor-pointer font-semibold text-base rounded-full px-6 py-4',
                    btnClassName,
                    {
                      'border border-border': overlay && backgroundColor === 'primary',
                    },
                  )}
                >
                  <div className="flex flex-1 items-center gap-2">
                    {link?.label}
                    <ChevronsRight />
                  </div>
                </Link>
                {overlay && <div className="absolute inset-0 bg-muted rounded-full z-0" />}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
